import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path d="M6 17H11V18H6V17Z" fill="currentColor" />
    <path
      d="M15.998 16.709L15.997 20H4.00195V4H11.5V7.5C11.5 8.051 11.949 8.5 12.5 8.5H16V8.842L16.743 7.554C16.729 7.537 16.722 7.515 16.707 7.5L12.5 3.293C12.314 3.107 12.056 3 11.793 3H4.00195C3.45095 3 3.00195 3.449 3.00195 4V20C3.00195 20.552 3.45095 21 4.00195 21H15.998C16.548 21 16.996 20.552 16.998 20L16.999 14.975L15.998 16.709ZM12.5 4.707L15.293 7.5H12.5V4.707Z"
      fill="currentColor"
    />
    <path
      d="M13 18L14.673 17.003L19.935 7.88903C20.068 7.65803 19.989 7.36303 19.758 7.22903L18.921 6.74603C18.845 6.70203 18.762 6.68103 18.68 6.68103C18.513 6.68103 18.351 6.76803 18.261 6.92303L13 16.037V18Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'LetterPen');

export default Icon;
